export enum GuestFields {
  id = "id",
  guestId = "guestId",
  firstName = "firstName",
  lastName = "lastName",
  gender = "gender",
  title = "title",
  jobTitle = "jobTitle",
  company = "company",
  email = "email",
  phone = "phone",
  mobile = "mobile",
  address = "address",
  address2 = "address2",
  zipCode = "zipCode",
  city = "city",
  country = "country",
  language = "language",
  emailOptIn = "emailOptIn",
  // SMS channel wave: the SMS consent twin — reserved so a custom field can
  // never shadow it.
  smsOptIn = "smsOptIn",
  // PB-TH-7: bounced-address suppression. Reserved here alongside emailOptIn so
  // a custom field can never shadow it — the two are shown side by side and
  // must not be confusable.
  emailUndeliverable = "emailUndeliverable",
  emailUndeliverableAt = "emailUndeliverableAt",
  username = "username",
  code = "code",
  state = "state",
  checkedIn = "checkedIn",
  checkedInAt = "checkedInAt",
  checkInOutCTA = "checkInOutCTA",
  numCompanions = "numCompanions",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  archived = "archived",
  actionRegistrant = "actionRegistrant",
  actionCompanion = "actionCompanion",
  companions = "companions",
  // Wave B: promoted-speaker backlink — reserved so a custom field can never
  // shadow the built-in marker.
  speakerId = "speakerId",
  sponsorId = "sponsorId",
  attachments = "attachments",
  slotting = "slotting",
  seating = "seating",
}
